import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50043be6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-weight-bold" }, "계약서 조회", -1))
const _hoisted_3 = { class: "pdf-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "pdf-container" }
const _hoisted_6 = ["src"]

import { useStore } from 'vuex';
import axios from "axios";
import { ref, reactive, onMounted } from "vue";

interface PdfUrls {
  comp: string | null;
  cms: string | null;
}

interface Loading {
  comp: boolean;
  cms: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompContract',
  setup(__props) {

const store = useStore();
const pdfUrls = ref<PdfUrls>({
  comp: null,
  cms: null
});

const loading = reactive<Loading>({
  comp: false,
  cms: false
});

const code = ref<string>('');
const form = reactive({
  send_name: "",
  send_rel_depo: "",
  send_phone: "",
  cms_playing_agree: true,
  cms_policy_agree: true,
  sisul_name: "",
  sisul_num: "",
  sisul_tell: "",
  cms_apply_gubun: "신규",
  recv_comp_name: "㈜함우리",
  recv_comp_boss: "김승식",
  recv_comp_addr: "전북특별자치도 전주시 덕진구 기지로77",
  recv_comp_biz_num: "185-81-02287",
  recv_bank_history: "업무위탁 수임료",
  recv_day: "매월 25일",
  payment_method: "계좌",
  bank_owner: "",
  bank_owner_birth: "",
  bank_name: "",
  send_biz_num: "",
  bank_num: "",
  bank_owner_phone: "",
  cms_contract_day: "2025-04-02",
});

const createPdfUrl = (pdfBase64: string) => {
  const binaryString = window.atob(pdfBase64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: "application/pdf" });
  return window.URL.createObjectURL(blob);
};

const getCompContract = async () => {
  try {
    loading.comp = true;
    const response = await axios.post(`/api/getCompContract/${code.value}`,
      { responseType: "json" }
    );
    pdfUrls.value.comp = createPdfUrl(response.data.pdf);
  } catch (error) {
    console.error("시설계약서 PDF 미리보기 중 에러 발생:", error);
  } finally {
    loading.comp = false;
  }
};

const getCMSContract = async () => {
  try {
    loading.cms = true;
    const level = 0;
    const response = await axios.post(
      `/api/getCMSContract/${level}`,
      { form: form },
      { responseType: "json" }
    );
    pdfUrls.value.cms = createPdfUrl(response.data.pdf);
  } catch (error) {
    console.error("자동이체 이용 신청서 PDF 미리보기 중 에러 발생:", error);
  } finally {
    loading.cms = false;
  }
};

onMounted(async () => {
  code.value = store.state.AdminSisulCode;
  await Promise.all([getCompContract(), getCMSContract()]);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "rounded-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  color: "primary",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-file")
                  ]),
                  _: 1
                }),
                _hoisted_2
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "h-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                start: "",
                                color: "primary",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-file-document-outline")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" 시설계약서 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, { class: "pa-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                (pdfUrls.value.comp)
                                  ? (_openBlock(), _createElementBlock("iframe", {
                                      key: 0,
                                      src: pdfUrls.value.comp,
                                      width: "100%",
                                      height: "1200",
                                      frameborder: "0"
                                    }, null, 8, _hoisted_4))
                                  : (_openBlock(), _createBlock(_component_v_sheet, {
                                      key: 1,
                                      class: "d-flex align-center justify-center",
                                      height: "1200"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_progress_circular, {
                                          indeterminate: "",
                                          color: "primary"
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "h-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                start: "",
                                color: "primary",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-file-document-outline")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" 자동이체 이용 신청서 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, { class: "pa-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                (pdfUrls.value.cms)
                                  ? (_openBlock(), _createElementBlock("iframe", {
                                      key: 0,
                                      src: pdfUrls.value.cms,
                                      width: "100%",
                                      height: "1200",
                                      frameborder: "0"
                                    }, null, 8, _hoisted_6))
                                  : (_openBlock(), _createBlock(_component_v_sheet, {
                                      key: 1,
                                      class: "d-flex align-center justify-center",
                                      height: "1200"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_progress_circular, {
                                          indeterminate: "",
                                          color: "primary"
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})